import Vue from 'vue'
import VueRouter from 'vue-router'
// import Approve from '../views/Approve.vue'
import index from '@/pages/home/index'
import mining from '@/pages/home/mining'
import calculate from '@/pages/home/calculate'
import my from '@/pages/home/my'
import pledge from '@/pages/home/pledge'
import history from '@/pages/home/history'
import lottery from '@/pages/home/lottery'
Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Approve',
  //   component: Approve
  // }
       {
		path: '/',
		name: 'index',
		component: index
		},
		{
		path: '/index',
		name: 'index',
		component: index
		},
		{
		 path: '/mining',
		 name: 'mining',
		 component: mining
		},
		{
		 path: '/calculate',
		 name: 'calculate',
		 component: calculate
		},
		{
		 path: '/my',
		 name: 'my',
		 component: my
		},
		{
		 path: '/history',
		 name: 'history',
		 component: history
		},
		{
		 path: '/pledge',
		 name: 'pledge',
		 component: pledge
		},
		{
		 path: '/lottery',
		 name: 'lottery',
		 component: lottery
		}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router